import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedComics from './components/FeaturedComics';
import HotRanking from './components/HotRanking';
import LatestUpdates from './components/LatestUpdates';

export default function Home() {
  const structuredData = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '韩漫阅读 - 韩国漫画无删减下拉式免费在线阅读',
      description: '专注耽美题材无删减韩国漫画，下拉式免费在线阅读模式便捷，优质耽美韩漫持续上新。',
      url: 'https://hanman.life/',
      isPartOf: {
        '@type': 'WebSite',
        name: '韩漫阅读',
        url: 'https://hanman.life/',
      },
    },
  ];

  return (
    <>
      <SEOHead
        title="韩漫阅读 - 韩国漫画无删减下拉式免费在线阅读 | 耽美漫画"
        description="韩漫阅读专注耽美题材无删减韩国漫画，提供下拉式免费在线阅读模式。涵盖校园、职场、奇幻、古风等多种分类，优质耽美韩漫持续上新。"
        keywords="韩国漫画,无删减漫画,下拉式韩漫,免费韩漫在线阅读,耽美漫画,韩漫,BL漫画"
        structuredData={structuredData}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedComics />
        <HotRanking />
        <LatestUpdates />

        <section className="px-4 md:px-6 py-10 md:py-14 text-center">
          <div className="max-w-2xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-3">
              开启您的韩漫阅读之旅
            </h2>
            <p className="text-foreground-600 mb-6 leading-relaxed">
              韩漫阅读致力于为耽美漫画爱好者提供最优质的阅读体验。从校园纯爱到奇幻冒险，
              从古风典雅到现代都市，各类韩国耽美漫画一应俱全。下拉式阅读让您沉浸其中，无删减内容保留原汁原味。
            </p>
            <div className="flex items-center justify-center gap-4 flex-wrap">
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-primary-500">{comicsCount}</p>
                <p className="text-xs text-foreground-500 mt-1">部精选漫画</p>
              </div>
              <div className="w-px h-10 bg-background-200" />
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-accent-500">{categoriesCount}</p>
                <p className="text-xs text-foreground-500 mt-1">个分类</p>
              </div>
              <div className="w-px h-10 bg-background-200" />
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-primary-500">{totalReads}</p>
                <p className="text-xs text-foreground-500 mt-1">万+总阅读量</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

const comicsCount = '50+';
const categoriesCount = '10';
const totalReads = '1500';